import styles from './border-radius.module.css';

import type { BreakpointSize } from '../Breakpoint';
import type { BorderRadiusSize } from './BorderRadius';

export type BorderRadiusResponsive = Partial<
  Record<BreakpointSize, BorderRadiusSize>
>;
/**
 * Return the CSS classes to style the colors of a component. To be used by
 * components that extend {@link BorderRadiusProp}.
 *
 * ```
 * type MyComponentProps = { borderRadius: BorderRadiusProp; ... };
 * function MyComponent(props: MyComponentProps) {
 *   const borderRadiusClassNames = getBorderRadiusStyles(props.borderRadius);
 *   return <div className={borderRadiusClassNames}>{props.children}</div>;
 * }
 *
 * <MyComponent borderRadius="md" /> // Will render a div with the class for "medium" border radius.
 * ```
 *
 * @internal
 */
export function getBorderRadiusStyles(
  size: BorderRadiusSize | BorderRadiusResponsive | undefined
) {
  const borderRadiusStyles: string[] = [];

  if (typeof size === 'string') {
    size = { xs: size };
  }

  if (size?.xs) {
    borderRadiusStyles.push(styles[`xs-border-radius-${size.xs}`]);
  }

  if (size?.sm) {
    borderRadiusStyles.push(styles[`sm-border-radius-${size.sm}`]);
  }

  if (size?.md) {
    borderRadiusStyles.push(styles[`md-border-radius-${size.md}`]);
  }

  if (size?.lg) {
    borderRadiusStyles.push(styles[`lg-border-radius-${size.lg}`]);
  }

  if (size?.xl) {
    borderRadiusStyles.push(styles[`xl-border-radius-${size.xl}`]);
  }

  return borderRadiusStyles;
}
